import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common'
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataService } from './../common-data.service';
import { environment } from './../../../environments/environment';
import { detectBody } from '../../app.helpers';
import { LmTsService } from '../learner-maps/lm-ts.service';
import { Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { CustomPfService } from './custom-pf.service';
import { Store } from '@ngrx/store';
import * as fsProfileActions from '../../store/action/fs.action';

declare var jQuery: any;

@Component({
  selector: 'app-custom-profile',
  templateUrl: './custom-profile.component.html',
  styleUrls: ['./custom-profile.component.scss'],
  host: {
        '(window:resize)': 'onResize()'
    }
})
export class CustomProfileComponent implements OnInit, OnDestroy {

    public profiles: any;
    public env;
    public id: any;
    public showContent: string = 'Profile Slideshow';
    public page_content: string = 'Profile Slideshow';
    audio_mute: boolean = false;
    args: any;
    public allcolumns: any;
    previousCard: string;
    nextCard: string;
    currentCard = new Subject();
    currentCard1;
    counter: number = 0;
    guide: any;
    guides: any;
    sorted_item: any = [];
    allitem: any = [];
    slideshows_obj = [];
    long_guide: string;
    short_guide: string;
    selectedGuide: any = '';
    ngrxTcwaProfile: any;

    private destroy$ = new Subject<void>();

    constructor(
        public activatedRoute: ActivatedRoute,
        private location: Location,
        public http: HttpClient,
        public service: CommonDataService,
        public router: Router,
        public lm_ts: LmTsService,
        public lmda_service: LambdaFunctionService,
        public customPfService: CustomPfService,
        public store: Store<any>
    ) { }

    cancel() {
        this.location.back();
    }

    ngOnDestroy() {
        localStorage.setItem('appNoli', 'false');
        document.title = "App | FourSight";
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.ngrxTcwaProfile = this.store.select<any>((state) => state.profile.tcwaProfile);
        document.title = "Thinking Coach | FourSight";
        localStorage.setItem('appNoli', 'true');
        $('.loader-container').css('display', 'flex');
        localStorage.setItem('collaboration-pf', 'false');
        this.store.dispatch(fsProfileActions.getTcwaProfile());

        // old slideshow route replace with new route
        let url: any = this.router.url;
        if (url.includes('slideshow')) {
            url = url.replace('slideshow', 'thinking-coach');
            this.location.replaceState(url);
        }

        detectBody();
        this.env = environment;

        this.lm_ts.an_slide_no.pipe(takeUntil(this.destroy$)).subscribe(val => {
            this.counter = val;
            this.currentCard.next(this.sorted_item[this.counter]);
        });

        this.currentCard.pipe(takeUntil(this.destroy$)).subscribe(val => {
            this.currentCard1 = val;
        });

        // Get route param and load profile
        this.activatedRoute.params.pipe(
            take(1)
        ).subscribe(params => {
            this.id = params.id;
            this.customPfService.trackActivity(this.id, 'thinking_coach_visited');

            this.ngrxTcwaProfile.pipe(
                takeUntil(this.destroy$),
                filter(res => !!res)
            ).subscribe(res => {
                this.profiles = res['profile'];

                if (res?.status == 422) {
                    $('.pf-expire-modal').css('display', 'block');
                    setTimeout(() => {
                        $('.modal.grey').css('pointer-events', 'none');
                        $('.modal-content').css('pointer-events', 'all');
                        $('.loader-container').css('display', 'none');
                    }, 100);
                    return;
                }

                // get all slideshow items (clear first to avoid duplicates)
                this.slideshows_obj = [];
                for (let i in this.profiles?.access_groups_json?.main_menu) {
                    if (i.includes('dlm_')) {
                        this.slideshows_obj.push(this.profiles?.access_groups_json?.main_menu[i]);
                    }
                }
                if (this.slideshows_obj.length > 0) {
                    this.args = { lm_id: this.slideshows_obj[0]?.value };
                    this.customPfService.active_lmsd_id.next(this.slideshows_obj[0].value);
                }

                if (this.profiles?.access_groups_json?.main_menu?.profile_slideshow?.lmproperties === true) {
                    this.customPfService.active_lmsd_id.next(this.profiles?.access_groups_json?.main_menu?.profile_slideshow?.value);
                }

                // move to dashboard when slideshow not available
                if (this.profiles?.access_groups_json?.main_menu?.profile_slideshow?.lmproperties != true && this.profiles?.access_groups_json?.main_menu != undefined || this.profiles === '' || this.profiles == null) {
                    this.showProfile("Dashboard");
                } else {
                    this.lambda_lmdata();
                    this.showProfile("Profile Slideshow", false);
                }
            }, err => {
                if (err.status == 422) {
                    $('.pf-expire-modal').css('display', 'block');
                } else {
                    alert('Unable to get the required info. Please contact support in the chat window below.');
                }
            });
        });

        this.customPfService.active_lmsd_id.pipe(takeUntil(this.destroy$)).subscribe(val => {
            if (val !== '') {
                this.args = { lm_id: val };
                this.sorted_item = [];
            }
        });
    }

    public printProfile() {
        $('.navbar-default').hide();
        $('body').addClass('print-body');
        window.print();
        $('.navbar-default').show();
        $('body').removeClass('print-body');
    }

    public printSlides() {
        document.title = 'Profile Slideshow';
        window.print();
        document.title = 'Thinking Coach | FourSight';
    }

    public showProfile(content, callLambda: boolean = true) {
        this.showContent = content;
        this.page_content = content;
        if (content == 'Profile Slideshow' && callLambda) {
            this.lambda_lmdata();
        }
    }

    public onResize() {
        detectBody();
    }

    public mute(val) {
        $('audio').prop('muted', val);
        this.audio_mute = val;
    }

    // fetch learnerMap data via Rails API
    public lambda_lmdata(i = 0) {
        this.allitem = [];
        this.sorted_item = [];

        try {
            this.lmda_service.lambda_res.next([]);
            this.http.get(`${environment.profileURL}/api/v1/public/learner_maps?title=Profile`).pipe(
                takeUntil(this.destroy$)
            ).subscribe((res: any) => {
                this.lmda_service.lambda_res.next(res?.learner_maps?.[0]?.learner_map_columns);
            });
        } catch (err) {
            console.error('Error fetching learner map data', err);
        }

        this.lmda_service.lambda_res.pipe(
            takeUntil(this.destroy$),
            filter(res => !!res && Array.isArray(res) && res.length > 0),
            take(1)
        ).subscribe(res => {
            const all_cards = res;
            try {
                all_cards.forEach(col => {
                    (col['learner_map_cards'] || []).forEach(card => {
                        this.allitem.push(card);
                    });
                });
            } catch (e) {
                console.error('error in try block custom-pf', e);
                return;
            }
            const sorting = [];
            this.allitem.forEach(element => {
                sorting[parseInt(element.position) - 1] = element;
            });
            sorting.forEach(el => {
                if (el?.active != false) {
                    this.sorted_item.push(el);
                }
            });
            this.allcolumns = this.sorted_item;
            this.currentCard.next(this.sorted_item[this.counter]);
        });

        // track slidemap start
        if (i == 0) {
            this.customPfService.trackActivity(this.id, 'profile_slide_map_start');
        }
    }

    // get interpretive guides
    public getGuides(content) {
        this.selectedGuide = '';
        this.guide = '';
        this.http.get(`${environment.assessment_admin}api/v1/interpretive_guides`).pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            data => {
                this.guides = data['interpretive_guides'].sort((a, b) => a.language_name.localeCompare(b.language_name));
                $('.guide-modal').css('display', 'block');
            },
            error => console.error('Error fetching guides', error)
        );
    }

    // change interpretive guides
    public changeGuide() {
        for (let i = 0; i < this.guides.length; i++) {
            if (this.guides[i].language_code == this.guide) {
                this.short_guide = this.guides[i].short_guide;
                this.long_guide = this.guides[i].long_guide;
            }
        }
    }

    // get guide
    public shortGuide() {
        if (this.selectedGuide.includes('Quick')) {
            this.customPfService.trackActivity(this.id, 'quick_guide_download');
        } else {
            this.customPfService.trackActivity(this.id, 'interpretive_guide_download');
        }
    }

    public changeUrl() {
        window.location.replace(`${this.env.assessment_admin}/thinking-coach`);
    }

}
